import React, { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";

import SideMenu from "../../../../Components/SideDrawer";
import PageHeader from "../../../../Components/Header";
import { employeeDormitoryReport } from "../../../../Api/Admin/AdminApi"
import { extractErrorMessage } from "../../../../Utils/ErrorUtlis";
import { getCompanyShortForm } from "../../../../Utils/CommonUtils"

const DormitoryByUser = () => {
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log('Inseide the useEffect');
    
    const fetchDormitory = async () => {
    console.log('Inseide the Function');
      try {
    console.log('Inseide the Try');
        const data = await employeeDormitoryReport();
        console.log('Dor data: ',data);
        if (data) {
          const dormitory = data.result.map(i => ({
            emp_id: i.emp_id,
            Name: i.Name,
            nationality: i.nationality,
            BLOCK: i.BLOCK,
            name: i.name,
            CompanyName: getCompanyShortForm(i.CompanyName)
          }));
          setApiData(dormitory);
          setIsLoading(true);
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Dormitory Report: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchDormitory();
  }, [])

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title="Dormitory User Report " showButtons={true} />
        <h4 className="mb-4 text-center fw-bold">
          Dormitory Details
        </h4>
        {!isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div tyle={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Employee Name</th>
                <th className="fs-12">Block Number</th>
                <th className="fs-12">Dormitory Name</th>
                <th className="fs-12">Company Name</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.Name}
                  </td>
                  <td className="fs-12">
                    {emp.BLOCK}
                  </td>
                  <td className="fs-12">
                    {emp.name}
                  </td>
                  <td className="fs-12">
                    {emp.CompanyName}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
      </Container>
    </div>
  );
};

export default DormitoryByUser;